import styled from 'styled-components';
import { key } from 'styled-theme';
import { media } from '@sizeid/commons/utils/styles';

export default styled.div`
  background: white;
  border-radius: ${key('sizes.borderRadius')};
  padding: 32px;

  h3 {
    text-align: center;
    margin-top: 0;
  }

  ${media.lessThan('sm')`
    padding: 24px;
  `};
`;
